import store from '../store'
import { get } from 'lodash'

const GTAG_ACTIVE = process.env.VUE_APP_GTAG_ACTIVE === 'active'

// docs
// https://github.com/gtm-support/vue-gtm/tree/vue2-gtm

const pageview = ({ pagePath, pageTitle, pageLocation, pageContentGroup, extraParams }) => {
  if (!pageLocation) pageLocation = window.location.href

  const userId = get(store, 'state.user._id')
  const userStatus = get(store, 'state.user.status')

  const params = {
    env: process.env.NODE_ENV,
    page_path: pagePath,
    page_title: `go-filios|${pageTitle}`,
    page_content_group: pageContentGroup,
    page_location: pageLocation,
    user_id: userId,
    user_status: userStatus,
    ...extraParams,
  }

  if (GTAG_ACTIVE)
    window.dataLayer.push({
      event: 'page_view',
      ...params,
    })
  else console.log('gtag page_view', params)
}

export default {
  pageview,
}
